import script from "./StripeCheckoutForm.vue?vue&type=script&setup=true&lang=js"
export * from "./StripeCheckoutForm.vue?vue&type=script&setup=true&lang=js"

import "./StripeCheckoutForm.vue?vue&type=style&index=0&id=487efc60&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-487efc60"]])

export default __exports__